import { Box, Typography } from "@outschool/backpack";
import { ListingCard_ListingFragment } from "@outschool/gql-frontend-generated";
import { pxToRem } from "@outschool/ui-utils";
import React from "react";

import ListingCarousel from "./ListingCarousel";

type MoreFromTeacherProps = {
  listings: ListingCard_ListingFragment[];
  carouselRowNum: number;
  title: string;
};
export const CdpMobileListingCarouselComponent = ({
  listings,
  carouselRowNum,
  title,
}: MoreFromTeacherProps) => {
  return (
    <>
      <ListingCarousel
        listings={listings}
        trackingLabel="more"
        carouselRowNum={carouselRowNum++}
        innerContainerSx={{
          px: 0,
          pb: 0,
          pl: pxToRem(16),
        }}
        sx={{ maxWidth: "100%", marginTop: "4rem" }}
        outerContainerSx={{ py: 0 }}
        titleElement={
          <Box
            flex
            sx={{
              justifyContent: "space-between",
              flexWrap: "wrap",
              mx: pxToRem(16),
              marginTop: "0.8rem",
            }}
          >
            <Typography emphasized variant={"h6"}>
              {title}
            </Typography>
          </Box>
        }
        isCrossSell={true}
      />
    </>
  );
};
